module.exports = __webpack_public_path__ + "img/6.0282f840.png";